<template>
	<div class="app-body">
		<apnic-nav-bar></apnic-nav-bar>
		<div id="wrapper" class="toggled navigation">
			<apnic-side-bar></apnic-side-bar>
			<!-- Page Content -->
			<main id="page-content-wrapper">
				<apnic-header></apnic-header>
				<router-view />
			</main>
		</div>
		<apnic-footer></apnic-footer>
	</div>
</template>

<script>
import Header from "./components/ui/Header";
import NavBar from "./components/ui/NavBar.vue";
import SideBar from "./components/ui/SideBar.vue";
import Footer from "./components/ui/Footer.vue";
import { mapActions } from "vuex";

export default {
	components: {
		apnicNavBar: NavBar,
		apnicSideBar: SideBar,
		apnicHeader: Header,
		apnicFooter: Footer
	},
	methods: {
		...mapActions(["fetchThemeDataList"])
	},
	mounted() {
		this.fetchThemeDataList();
	}
};
</script>


<style lang="scss">
// fix footer position when content is not long enought, martyna is aware of this, so should be fixed in later release
main#page-content-wrapper {
	min-height: calc(100vh - 147px);
}
</style>
